/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { StatusType } from "./status-type";

export class UserStatusInfoRemoteDto {
    id: number;
    customStatusName: string;
    type: StatusType;
    isSelectable: boolean;
}
